export default {"src":"/_next/static/media/KPMG.c357506e.svg","height":76,"width":188,"blurWidth":0,"blurHeight":0};